<template>
	<div class="index-swiper-view">
		<div class="backpage">
			<div class="header-bar__wrap left">
				<img
					class="back-img"
					src="@/assets/images/back.png"
					alt="后退"
					@click="onBack" />
			</div>
			<div class="datatitle">
				{{dataTitle}}
			</div>
		</div>
		<van-pull-refresh
			v-model="isRefreshing"
			@refresh="onRefresh"
			id="indexNewsList">
			<!-- v-show="newsItemList.length>0" v-if="newsItemList.length>0"-->
			<!-- <div
					v-show="newsItemList.length>0"
					class="news-list"
					id="newslist"> -->
					<van-swipe ref="swipe"
						v-if="newsItemList.length>0"
						:loop="false"
						:show-indicators="false">
					<van-swipe-item 
							istance="80" 
							v-infinite-scroll="loadMore"
							:infinite-scroll-disabled="bottomLoading"
						>
							<!-- :key="index" -->
						<NewsItem
							v-for="item in newsItemList"
							:key="item.id" 
							infinite-scroll-d
							:gene-id="$route.query.id"
							v-bind="item"
							:beforeClick="()=>{onNewsItemClick(item.id)}" />
					</van-swipe-item>
				</van-swipe>
			<!-- </div> -->
			<div v-else>
				<div class="no-content">————    暂无内容    ————</div>
			</div>
		</van-pull-refresh>
	</div>
</template>
<script>

import HeaderBar from '../../components/HeaderBar';
import { Swipe, SwipeItem } from 'vant'
import { getUser, getChannel, getChannels, getFollowingChs } from '../../utils/storageUtil'
import apiUtil from '../../utils/apiUtil'
import apiConst from '../../consts/apiConst'
import NewsItem from '../../components/NewsItem'
import TagItem from '../../components/TagItem'
import DigitalItem from '../../components/DigitalItem'
import CourseItem from '../../components/CourseItem'
import BannerItem from '../../components/BannerItem'
import PopLoading from '../../components/PopLoading'
export default {
	name: 'dataList',
	components: {
		HeaderBar,
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		NewsItem,
		TagItem,
		DigitalItem,
		CourseItem,
		BannerItem,
		PopLoading
	},
	props: {
		selectedNavItemId: {
			type: Number,
			default: 1
		},
		viewedNewsId: {
			type: Number,
			default: 0
		},
		firstLoadedHandler: {
			type: Function,
			default: () => { }
		}
	},
	data() {
		return {
			dataTitle: '媒体报道',
			bannerList: [],
			newsItemList: [],
			tagItemList: [],
			collegeList: [],
			digitalList: [],
			curPageSize: 10,
			groupNewsItemList: [],
			newList: [],
			showAllTag: false,
			isLoading: false, // 是否正在加载（菊花）
			isRefreshing: false, // 是否正在下拉刷新
			// 以下只有other才会用到
			bottomLoading: false, // 是否正在触底加载
			page: 1,
			loadFinished: false, // 分页加载是否结束
			isNoContent: false, // 是否无内容
			firstLoaded: false // 是否已经首次加载
		}
	},
	created() {
	},

	computed: {
		tagItemListOnShow() {
			return this.showAllTag
				? this.tagItemList
				: this.tagItemList.slice(0, 9)
		}
	},
	watch: {
		selectedNavItemId(val) {
			this.initView(val);
		}
	},
	mounted() {
		this.onRefresh()
	},
	methods: {
		onBack() {
			this.$router.push({
				path: '/data'
			})
		},
		async onFavClick() {
			const res = await apiUtil.post(apiConst.submitFav, {
				id: this.$route.query.id,
				type: 1
			});
			if (res.success) {
				this.is_collect = 1;
				Toast({
					message: '收藏成功',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},
    showList(id) {
      console.log(id)
      if(id==1) {
        this.newsItemList = [{
          "id": 9497,
          "title": "应对新冠肺炎疫情居家期间安全健康使用照明的建议",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "理论基础",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9496,
          "title": "积极培育条件适宜的超低能耗和近零能耗示范项目",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "理论基础",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9494,
          "title": "如何净化空气，一起来看",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "理论基础",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        },{
          "id": 9498,
          "title": "应对新冠肺炎疫情居家期间安全健康使用照明的建议",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "理论基础",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9499,
          "title": "积极培育条件适宜的超低能耗和近零能耗示范项目",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "理论基础",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9450,
          "title": "如何净化空气，一起来看",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "理论基础",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }]
      } else if(id==2) {
        this.newsItemList = [{
          "id": 9497,
          "title": "走向新住宅 ： 从「致病宅」到「理想家」",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年报告",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9496,
          "title": "健康建筑，离我们并不远",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年报告",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9494,
          "title": "构建智慧城市",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年报告",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        },{
          "id": 9493,
          "title": "走向新住宅 ： 从「致病宅」到「理想家」",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年报告",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9492,
          "title": "健康建筑，离我们并不远",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年报告",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9491,
          "title": "构建智慧城市",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年报告",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }]
      } else if(id==3) {
        this.newsItemList = [{
          "id": 9497,
          "title": "中国推进工业园区绿色发展-中国与国际绿",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年排名",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9496,
          "title": "健康建筑，离我们并不远",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年排名",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9494,
          "title": "构建智慧城市",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年排名",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        },{
          "id": 9495,
          "title": "中国推进工业园区绿色发展-中国与国际绿",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "历年排名",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }]
      } else {
        this.newsItemList = [{
          "id": 9497,
          "title": "绿地集团发布健康宅2.0！“全健康思维”下的产品升级",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "媒体报道",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9496,
          "title": "英特尔押注以色列的智能建筑吸引顶尖技术人才",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "媒体报道",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }, {
          "id": 9494,
          "title": "地产科技行业的四大潜在投资机会",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "媒体报道",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        },{
          "id": 949117,
          "title": "英特尔押注以色列的智能建筑吸引顶尖技术人才",
          "publish_date": "2020-09-29",
          "cover": "http://ceshi.igreen.org/upload/20200929/a83250dc1f93ada1/a8465a18b67236dc.png",
          "view": 1,
          "cate_name": "媒体报道",
          "nickname": "小柠檬",
          "action_id": 10000,
          "is_admin_publish": 0
        }]
      }
    },
		/**
		 * @param isDragDown 是否由下拉刷新触发
		 */
		async initView() {
			// if (selectedNavItemId === 1) {
			// 	this.initIndexView(isDragDown)
			// } else {
			// 	this.initOtherView(selectedNavItemId, 1, isDragDown)
			// }
			var id = 101
			if (this.$route.query.type == 1) {
				id = 101
			} else if (this.$route.query.type == 2) {
				id = 102
			} else if (this.$route.query.type == 3) {
				id = 103
			} else if (this.$route.query.type == 4) {
				id = 104
			}
			let qId = this.$route.query.id
			let newList = []
			if (qId == 1) {
				// 理论基础
				const botList = await apiUtil.get(apiConst.tabList, { id: id,page: this.page, tag_type: 'theoretical_basis' });
				newList = botList.theoretical_basis.list
				this.dataTitle = botList.theoretical_basis.top_title
				this.curPageSize = botList.theoretical_basis.list.length
			} else if (qId == 2) {
				// 历届排名
				const botList = await apiUtil.get(apiConst.tabList, { id: id,page: this.page, tag_type: 'annual_report' });
				newList = botList.annual_report.list
				this.dataTitle = botList.annual_report.top_title
				this.curPageSize = botList.annual_report.list.length
			} else if (qId == 3) {
				// 历年报告
				const botList = await apiUtil.get(apiConst.tabList, { id: id,page: this.page, tag_type: 'annual_ranking' });
				newList = botList.annual_ranking.list
				this.dataTitle = botList.annual_ranking.top_title
				this.curPageSize = botList.annual_ranking.list.length
			} else if (qId == 4) {
				// 媒体报告
				const botList = await apiUtil.get(apiConst.tabList, { id: id,page: this.page, tag_type: 'media_coverage' });
				newList = botList.media_coverage.list
				this.dataTitle = botList.media_coverage.top_title
				this.curPageSize = botList.media_coverage.list.length
			}
			this.newsItemList = this.newsItemList.concat(newList);
			console.log(this.newsItemList)
			this.firstLoaded = true
		},

		async initIndexView(isDragDown) {
      // 根据ID来区分类别
      this.showList(this.$route.query.id)
		},
		async initOtherView(selectedNavItemId, page = 1, isDragDown) {
			let params = { cate_id: selectedNavItemId, page, pagesize: 50 };
			if (selectedNavItemId == 2) {
				const user = getUser();
				if (!user) {
					const channels = getFollowingChs();
					if (!!channels) {
						params.localstorage = channels.map(ele => ele.id);
					}
				}
			}
			if (!isDragDown) {
				this.isLoading = true
			}
			const res = await apiUtil.post(apiConst.getOther, params)
			this.isLoading = false;
			this.isRefreshing = false
			if (res.success) {
				const {
					list
				} = res
				this.page = page;
				if (list.length === 0) {
					this.isNoContent = true;
					this.firstLoaded=true;
					return;
				}
				if (this.firstLoaded) {
					this.newsItemList = this.newsItemList.concat(list);
				} else {
					this.newsItemList = list;
					this.scrollToNewsItem(isDragDown)
				}
				this.firstLoadedHandler();
				if (list.length < 50) {
					this.loadFinished = true;
				}
				this.firstLoaded = true;
			}
		},

		scrollToNewsItem(isDragDown) {
			if (this.viewedNewsId && !isDragDown) { // 下拉刷新是不需要定位到刚刚访问的newsItem的
				this.$nextTick(() => {
					let dom = document.getElementById('news_' + this.viewedNewsId);
					if (dom) {
						this.scrollToPos(dom.offsetTop - 250)
					}
				})

			}
		},

		scrollToPos(dis) {
			this.$nextTick(() => {
				setTimeout(() => {
					let scrollTop;
					if (this.selectedNavItemId == 1) {
						scrollTop = this.$el.querySelector('#indexNewsList')
					} else {
						scrollTop = this.$el.querySelector('#otherNewsList')
					}
					console.log(dis)
					scrollTop.scrollTop = dis
				}, 13)
			})
		},

		onNewsItemClick(id) {
			let query = {
				newsId: id,
				type: this.$route.query.type,
				id: this.$route.query.id
			}
			if (this.selectedNavItemId !== 1) {
				query.cate_id = this.selectedNavItemId
			}
			this.$router.push({ query })
		},

		resetView() {
			this.page = 1;
			this.loadFinished = false;
			this.isNoContent = false;
			this.firstLoaded = false;
			this.newsItemList = [];
			// this.$nextTick(() => {
			// 	let dom = document.getElementById('newslist');
			// 	if (dom) {
			// 		this.scrollToPos(dom.offsetTop - 250)
			// 	}
			// })
		},

		onTagClick(tag_id) {
			this.$router.push({ name: 'filtered', query: { tag_id } })
		},
		onRefresh() {
			this.resetView();
			this.initView()
			this.isLoading = false
			this.isRefreshing = false
		},
		loadMore() {
			console.log(this.firstLoaded)
			if (this.curPageSize == 10 && this.firstLoaded) {
				this.page += 1
				this.initView()
			}
		},
	}
}
</script>

<style lang="stylus" scoped>
.index-swiper-view {
	height: 100%;
	overflow-y: auto;
	.no-content {
		height: 90px;
		line-height: 90px;
		color: #999;
		text-align: center;
	}
	.backpage{
		position: sticky;
		top: 0;
		left: 0;
		right: 0;
		display: flex;
		align-items: center;
		height: 88px;
		padding: 12px 30px;
		background-color: #fff;
		z-index: 999;
		transition: all .2s linear;
		.back-img {
			width: 24px;
			height: 40px;
		}
		.datatitle{
			width: 100%;
			text-align: center;
			color #666;
			font-size 30px;
		}
	}
	.van-pull-refresh {
		-webkit-overflow-scrolling: touch
		.van-swipe {
			height: auto !important;

			.swiper-banner-wrap {
				margin: 30px auto;
				width: 690px;
				height: 273px;
				border-radius: 12px;
				overflow: hidden;

				.banner-img {
					display: block;
					width: 100%;
					height: 100%;
				}
			}
		}

		.tag-list {
			margin: 0 15px;
			padding-top: 23px;
			border-bottom: 2px solid #F1F1F1;

			.tag-item-comp {
				margin: 0 10px 23px;
			}
		}

		.college-list {
			padding: 20px 0;

			.course-item-comp {
				margin-left: 30px;
				margin-bottom: 30px;
				vertical-align: top;
			}
		}

		.digital-list {
			padding: 20px 0;

			.digital-item-comp {
				margin-left: 30px;
				margin-bottom: 30px;
				vertical-align: top;
			}
		}

		.group-news-list {
			.group-news-item {
				margin-bottom: 23px;

				.banner-wrap {
					padding: 0 30px;
					height: 273px;
					overflow: hidden;

					.banner-img {
						width: 100%;
						height: 100%;
						border-radius: 12px;
					}
				}
			}
		}
	}

	.news-list {
		padding: 0 15px;
	}

	.sub-view--other {
		height: 100%;

		.news-list {
			position: relative
			height: 100%;
			overflow-y: auto;

			.no-content {
				height: 90px;
				line-height: 90px;
				color: #999;
				text-align: center;
			}

			.no-content-wrap{
				text-align: center;
				.no-fav-img {
					margin-top: 20px;
				width: 400px;
			}
			}

			
		}
	}
}
</style>